import getSdkSession from './utils/getSdkSession';
import isExpired from './utils/isExpired';

const localStorageSubscriptionsKey = '__btm__web_user_subscriptions';

const Subscription = {

    getSdkSession,

    isExpired,

    localStorageSubscriptionsKey,

    async getSubscriptions() {
        const sdkSession = await Subscription.getSdkSession();
        const { subscriptionApi } = sdkSession;
        const subs = await subscriptionApi.getSubscriptions();
        return subs;
    },

    async setSubscriptionsInLocalStorage(subscriptions, externalId) {
        if (!Array.isArray(subscriptions) || (!typeof externalId === 'string')) {
            throw new Error('You must pass subscriptions array and an externalId string to setSubscriptionsInLocalStorage.');
        }
        const activeSubscriptions = subscriptions.filter((sub) => {
            return sub.isActive &&
                sub.status.type === 'SUBSCRIBED' &&
                sub.products[0] &&
                sub.products[0].entitlements[0] &&
                sub.products[0].entitlements[0].name;
        }).map((sub) => {
            return sub.products[0].entitlements[0].name;
        });
        const expires = new Date();
        expires.setDate(expires.getDate() + 1);
        const localStorageSubscriptionsObj = {
            expires,
            data: {
                externalId,
                activeSubscriptions
            }
        };

        const stringifiedSubscriptionsObj = JSON.stringify(localStorageSubscriptionsObj);
        localStorage.setItem(localStorageSubscriptionsKey, stringifiedSubscriptionsObj);
        return true;
    },

    async getSubscriptionsFromLocalStorage() {

        const localStorageItem = JSON.parse(localStorage.getItem(localStorageSubscriptionsKey));
        if (localStorageItem && !isExpired(localStorageItem.expires)) {
            return localStorageItem;
        }

        return null;
    },

    async removeSubscriptionsFromLocalStorage() {
        return localStorage.removeItem(localStorageSubscriptionsKey);
    }

};

export default Subscription;
